import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-mp-black pt-28 pb-16 md:pt-40 md:pb-24" data-id="element-152" data-mp="4n9z0lnv3m4r">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-60" aria-hidden="true" data-id="element-153" data-mp="128yzydv6bxz6" />
      <div className="pointer-events-none absolute -top-40 right-0 h-[520px] w-[520px] rounded-full opacity-50 md:right-10" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.35), transparent 65%)'
    }} aria-hidden="true" data-id="element-154" data-mp="xb5slhi4wxxb" />
      <Container className="relative z-10" data-id="element-155" data-mp="3d1sayygxbltn">
        <div className="flex flex-col items-center gap-12 md:flex-row md:items-center md:gap-8" data-id="element-156" data-mp="3czfk1vt6u14g">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut
        }} className="w-full md:w-[52%]" data-id="element-157" data-mp="384js0vnybdrc">
            <SectionTag tone="lime" data-id="element-158" data-mp="39acwgl67hgrf">Para monitores y entrenadores de pádel</SectionTag>

            <h1 className="mt-5 font-heading text-4xl font-semibold uppercase leading-[1.05] text-mp-white sm:text-5xl md:text-[3.4rem]" data-id="element-159" data-mp="39cpbapgo3b09">
              Deja de improvisar clases.
              <br data-id="element-160" data-mp="30gq65akrp5pm" />
              Empieza a dirigirlas <span className="text-mp-lime" data-id="element-161" data-mp="358ho4wpuy345">como un profesional</span>.
            </h1>

            <p className="mt-6 max-w-[650px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-162" data-mp="2qjvaczfvpjf1">
              El sistema práctico para monitores de pádel que quieren preparar mejores clases en menos tiempo,
              corregir con más criterio y conseguir que sus alumnos noten una progresión real.
            </p>

            <p className="mt-5 font-heading text-xs uppercase tracking-[0.18em] text-mp-electric md:text-sm" data-id="element-163" data-mp="2lla9cxssyvpj">
              5 Tomos + 5 Herramientas Prácticas + 250+ Páginas
            </p>

            {/* Mobile mockup sits after subtitle/product line, before price + CTA */}
            <div className="mt-8 md:hidden" data-id="element-164" data-mp="ic889f9986xu">
              <HeroMockup priority data-id="element-165" data-mp="id04msaoe8p6" />
            </div>

            <div className="mt-8 rounded-2xl border border-mp-border bg-mp-card/60 p-5 md:mt-10 md:p-6" data-id="element-166" data-mp="ddf3qcby3q9t">
              <p className="font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-167" data-mp="1b0nizplcs33d">Maestro en Pista</p>
              <p className="font-heading text-sm uppercase tracking-wide text-mp-gray" data-id="element-168" data-mp="161b01fxlrg62">
                El Manual del Monitor de Pádel
              </p>
              <p className="mt-2 text-xs uppercase tracking-[0.15em] text-mp-gray" data-id="element-169" data-mp="114swgje0dnvb">
                Técnica · Táctica · Metodología · Liderazgo
              </p>

              <div className="mt-5 flex flex-wrap items-end justify-between gap-4 border-t border-mp-border pt-5" data-id="element-170" data-mp="3lu03d2iot709">
                <div data-id="element-171" data-mp="3hpsdv34enn0z">
                  <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-lime" data-id="element-172" data-mp="3htgaib55cpjx">
                    Oferta de lanzamiento
                  </p>
                  <p className="font-heading text-3xl uppercase text-mp-white md:text-4xl" data-id="element-173" data-mp="21bxzf8gseycx">
                    Desde <span className="text-mp-lime" data-id="element-174" data-mp="268y4bg1whv2g">17,90 €</span>
                  </p>
                </div>
              </div>

              <CTAButton href="#oferta" className="mt-5 w-full" showArrow data-id="element-175" data-mp="2b20s17jzyaaq">
                Quiero profesionalizar mis clases
              </CTAButton>

              <p className="mt-4 text-center text-xs text-mp-gray sm:text-sm" data-id="element-176" data-mp="2kydscoa1rmeg">
                ✓ Acceso inmediato &nbsp; ✓ Formato digital &nbsp; ✓ Pago único
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: easeOut,
          delay: 0.1
        }} className="hidden w-full md:block md:w-[48%]" data-id="element-177" data-mp="2tyiryc901gi2">
            <HeroMockup priority data-id="element-178" data-mp="zndp3a5ql83s" />
          </motion.div>
        </div>
      </Container>
    </section>;
}
function HeroMockup({
  priority = false
}: {
  priority?: boolean;
}) {
  return <div className="relative" data-id="element-179" data-mp="3vjrr04vnnjow">
      <div className="pointer-events-none absolute inset-0 -z-10 rounded-full opacity-70 blur-2xl" style={{
      background: 'radial-gradient(circle, rgba(8,117,209,0.4), transparent 70%)'
    }} aria-hidden="true" data-id="element-180" data-mp="e9a6s4becyl5" />
      <img src={FULL_MOCKUP_URL} alt="Kit completo Maestro en Pista: 5 tomos, 5 bonos y Kit de Ejecución" width={800} height={800} fetchPriority={priority ? 'high' : 'auto'} loading={priority ? 'eager' : 'lazy'} className="mx-auto w-full max-w-[560px] drop-shadow-2xl" data-id="element-181" data-mp="3hr26k4vrymtw" />
    </div>;
}